import './_layout.scss';
import React, {useState} from 'react';
import {MessageBox} from '../message-box/message-box';
import {SearchPageType} from './search-config';
import {SearchPreviewAndDetails} from './search-results/searchPreviewAndDetails';
import {useStateDocsCount, useStateQueryPending, useStateShowFullDocument} from './search-hooks';
import {SearchResultsComponent} from './search-results/searchResultsComponent';
import {Spinner} from '../common/spinner/spinner';
import {Facets} from '../facets/Facets';

type InputProps = {
    searchPageType: SearchPageType;
};

export const SearchPageTypeContext = React.createContext<SearchPageType>(SearchPageType.BASIC);

export const SearchComponent = React.memo((props: InputProps) => {
    const visible = useStateShowFullDocument();
    return (
        <SearchPageTypeContext.Provider value={props.searchPageType}>
            <MessageBox id={props.searchPageType}/>
            {!visible && <MainSearchContent {...props} />}
        </SearchPageTypeContext.Provider>
    );
});

export const MainSearchContent = React.memo((props: InputProps) => {
    const [showSidebar, setShowSidebar] = useState(false);
    const docsCount = useStateDocsCount();
    const queryPending = useStateQueryPending();

    const isNewQuery = () => {
        return queryPending && docsCount === 0;
    };

    return (
        <div className="page-content gradient-background" id={'page-content__' + props.searchPageType}>
            <div id="hibu_content">
                <div id="hibu_main_row">
                    <Facets showSidebar={showSidebar} closeDrawer={() => setShowSidebar(false)}/>
                    {isNewQuery() ? (
                        <Spinner/>
                    ) : (
                        <>
                            <SearchResultsComponent
                                showSidebar={showSidebar}
                                toggleShowSidebar={() => setShowSidebar(!showSidebar)}
                            />
                            <SearchPreviewAndDetails/>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
});
